import { render, staticRenderFns } from "./LoginBuAccount.vue?vue&type=template&id=1237e2ee&scoped=true&"
import script from "./LoginBuAccount.vue?vue&type=script&lang=js&"
export * from "./LoginBuAccount.vue?vue&type=script&lang=js&"
import style0 from "./LoginBuAccount.vue?vue&type=style&index=0&id=1237e2ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1237e2ee",
  null
  
)

export default component.exports